export default __webpack_public_path__ + "static/media/Gwendolyn_Dolske_AHV_In_Moms_We_Trust.e12dd057.jpg";